import React from 'react';
import { Paper, Box, Typography, Badge, Grid } from '@mui/material';
import OrdenCard from './OrdenCard';

/**
 * Componente de columna Kanban para mostrar órdenes por estado
 * @param {object} estado - Estado de la columna
 * @param {array} ordenes - Lista de órdenes en este estado
 * @param {function} onViewOrden - Callback al ver una orden
 * @param {function} onUpdateOrden - Callback al actualizar una orden
 */
const KanbanColumn = ({ estado, ordenes = [], onViewOrden, onUpdateOrden }) => {
  // No mostrar columnas vacías
  if (ordenes.length === 0) return null;

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={estado.id}>
      <Paper sx={{
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
        borderRadius: 3,
        overflow: 'hidden',
        height: 'calc(100vh - 400px)',
        minHeight: '500px',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid rgba(26, 35, 126, 0.1)',
        boxShadow: `0 8px 32px ${estado.color}15`
      }}>
        {/* Header de la columna mejorado */}
        <Box sx={{
          p: 2,
          background: `linear-gradient(135deg, ${estado.color}, ${estado.color}E6)`,
          color: 'white',
          boxShadow: `0 4px 15px ${estado.color}40`
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{
              fontWeight: 'bold',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}>
              {estado.nombre}
            </Typography>
            <Badge
              badgeContent={ordenes.length}
              sx={{
                '& .MuiBadge-badge': {
                  background: 'linear-gradient(135deg, #ffffff, #f5f5f5)',
                  color: estado.color,
                  fontWeight: 'bold',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                }
              }}
            >
              <Box />
            </Badge>
          </Box>
        </Box>

        {/* Contenido scrolleable mejorado */}
        <Box sx={{
          flex: 1,
          overflow: 'auto',
          p: 1,
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'rgba(26, 35, 126, 0.05)',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: `linear-gradient(135deg, ${estado.color}, ${estado.color}CC)`,
            borderRadius: '10px',
            '&:hover': {
              background: estado.color
            }
          }
        }}>
          {ordenes.map((orden) => (
            <OrdenCard
              key={orden.id_orden_servicio}
              orden={orden}
              estado={estado}
              onView={onViewOrden}
              onUpdate={onUpdateOrden}
            />
          ))}
        </Box>
      </Paper>
    </Grid>
  );
};

export default KanbanColumn;
